import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useCallback } from 'react';
import { PowerPlayerBolt } from '../../../assets/powerPlayerBolt';
import { FormControlContainer } from '../../../components/formControlContainer';
import { IconWithLabelDisplay } from '../../../components/iconWithLabelDisplay';
import { isConfigFlagEnabled } from '../../../config';
import { setCreateGameIsPowerPlayersOnly } from '../../../redux/actions/createGameActions';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
export const PowerPlayersOnlyControlContainer = () => {
    const dispatch = useAppDispatch();
    const isPowerPlayer = useAppSelector((state) => state.selfData.isPowerPlayer);
    const myPlayerId = useAppSelector((state) => state.selfData.id);
    const isPowerPlayersOnlyEnabled = useAppSelector((state) => state.createGame.isPowerPlayersOnly);
    const roomType = useAppSelector((state) => state.createGame.roomType);
    const onChange = useCallback((event) => {
        dispatch(setCreateGameIsPowerPlayersOnly(event.target.checked));
    }, [dispatch]);
    if (!isPowerPlayer) {
        // must be power player to create a power-player-only room
        return null;
    }
    if (roomType === 'all-insanity') {
        // control not relevant
        return null;
    }
    if (isConfigFlagEnabled('powerPlayerOnlyGamesMustBeCreatedBySuperAdmin') && myPlayerId !== 1) {
        return null;
    }
    return (_jsx(FormControlContainer, { isFlex: true, children: _jsx(FormControl, { component: 'fieldset', children: _jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: isPowerPlayersOnlyEnabled, onChange: onChange }), label: _jsx(IconWithLabelDisplay, { label: 'Power Players Only', icon: _jsx(PowerPlayerBolt, { color: 'yellow' }) }) }) }) }));
};
